<p-tabMenu [model]="tabs" [(activeItem)]="activeTab" id="notification-settings-tabs"></p-tabMenu>

<div class="notification-settings-panel-detail">
  @if (activeTab.id === 'spanva') {
    <casb-notifications></casb-notifications>
  }
  @if (activeTab.id === 'audit') {
    <casb-audit-notifications></casb-audit-notifications>
  }
</div>
